import * as yup from "yup";

export const validationSchema = () => {
  let shapes = {
    template: yup.mixed().required().label("Template Report"),
    brand_ids: yup.array().min(1).required().label("Brand"),
  };
  return yup.object().shape(shapes);
};
